<script>
import * as d3 from "d3";
export let obj;

import {
    onMount
} from "svelte";

const width = 650;
const height = 200;

onMount(() => {

		const svg = d3.select(".movies-in")
			.append("svg")
			.attr("viewBox", `0 0 ${width} ${height}`)
      .style("max-width", "600px")
      .style("overflow", "visible");

			svg.append("text")
			.attr("transform", `translate(${width/2},150)`)
			.attr("text-anchor", "middle")
			.attr("dominant-baseline", "central")
			.attr("stroke", "#ccc")
			.attr("fill", "#222")
			.attr("stroke-width", 0.5)
			.attr("font-size", 45)
			.attr("font-weight", 900)
			.text(obj.movie)

		svg.append("text")
			.attr("transform", `translate(${width/2},50)`)
			.attr("text-anchor", "middle")
			.attr("dominant-baseline", "central")
			.attr("stroke", "#222")
			.attr("fill", "none")
			.attr("stroke-width", 1.5)
			.attr("font-size", 85)
			.attr("font-weight", 900)
			.text("Colors in")
	});

</script>

<div class="pt-5 movies-in">
</div>

<style>
</style>
